import { render, staticRenderFns } from "./GeoDataChart.vue?vue&type=template&id=f24177b6&scoped=true&"
import script from "./GeoDataChart.vue?vue&type=script&lang=js&"
export * from "./GeoDataChart.vue?vue&type=script&lang=js&"
import style0 from "./GeoDataChart.vue?vue&type=style&index=0&id=f24177b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24177b6",
  null
  
)

export default component.exports